import { Entity } from '@backstage/catalog-model'
import { MissingAnnotationEmptyState, useEntity } from '@backstage/plugin-catalog-react'
import { AWS_LAMBDA_TAGS_ANNOTATION } from '@internal/backstage-plugin-veho-backstage-common'
import { Route, Routes } from 'react-router-dom'

import { AwsLambdaTable } from './AwsLambdaTable/AwsLambdaTable'

export const isAwsLambdaAvailable = (entity: Entity): boolean => {
  return !!entity?.metadata?.annotations?.[AWS_LAMBDA_TAGS_ANNOTATION]
}

export const Router = () => {
  const { entity } = useEntity()

  if (!isAwsLambdaAvailable(entity)) {
    return <MissingAnnotationEmptyState annotation={AWS_LAMBDA_TAGS_ANNOTATION} />
  }

  return (
    <Routes>
      <Route path="/" element={<AwsLambdaTable entity={entity} />} />
    </Routes>
  )
}
